export const APP_PATH = {
    ESID_EXPORT: {path: '/nvesid/EsidList', key: 'esidExport', displayTitle: 'Danh sách/ ESID List'},
    ESID_ACPT: {path: '/nvesid', key: 'esidExportAcpt', displayTitle: 'Tiếp nhận hàng/ Finalize'},
    ESID_PERMISSION: {path: '/nvesid/Permission', key: 'esidPermission', displayTitle: 'Phân quyền/ Permission'},
    HOME: {path: '/', key: 'tcsWeb', displayTitle: 'Home'},
    OVERVIEW: {path: '/nvesid', key: 'adminDashboard', displayTitle: 'Admin Dashboard'},
}